import { makeAutoObservable } from 'mobx'
import type { Academy } from 'src/dto'

import { localStorageService } from '@/service/storage.service'

import type { PermissionChecker } from '.'
import { FeaturePermission } from './FeaturePermission'
import { RoutePermission } from './RoutePermission'

export class UserPermission implements PermissionChecker {
  private readonly _routePermission: RoutePermission
  private readonly _featurePermission: FeaturePermission

  private _userAuthority: res.Teacher['type']
  private _academyFeatureAuthority: res.Academy['authority']
  /**
   * @deprecated
   * TODO: 저작권 이슈 - 임시 코드. 제거 기한 미정
   */
  isLimited: boolean // TODO: 저작권 이슈 - 임시 코드. 제거 기한 미정

  constructor({
    userAuthority,
    academyFeatureAuthority,
    subscribedCurriculums,
    payStatus = '무료체험',
    isLimited,
    isSeoltab,
    isFranchise,
  }: {
    userAuthority: res.Teacher['type']
    academyFeatureAuthority: res.Academy['authority']
    subscribedCurriculums: res.Academy['subscribeItems']
    payStatus: Academy['payStatus']
    isLimited: boolean // TODO: 저작권 이슈 - 임시 코드. 제거 기한 미정
    isSeoltab: boolean
    isFranchise: boolean
  }) {
    makeAutoObservable(this)
    this._userAuthority = userAuthority
    this._academyFeatureAuthority = academyFeatureAuthority

    this._routePermission = new RoutePermission(
      this._userAuthority,
      payStatus,
      isLimited,
      isSeoltab,
      isFranchise,
    )
    this._featurePermission = new FeaturePermission({
      academyFeatureAuthority: this._academyFeatureAuthority,
      payStatus,
      subscribeItems: subscribedCurriculums,
      isSeoltab,
    })

    this.isLimited = isLimited
  }

  get get() {
    return this._routePermission.permissionByStatus
  }

  get byFeature() {
    return this._featurePermission
  }

  get hasBasicAuth() {
    return this.checkPermission('BASIC')
  }

  get hasPremiumAuth() {
    return this.checkPermission('PREMIUM')
  }

  get hasSoloAuth() {
    return this.checkPermission('SOLO')
  }

  checkPermission(target?: res.Academy['authority']): boolean {
    if (!target) return false
    return this._academyFeatureAuthority === target
  }

  /**
   * @deprecated
   * TODO: 저작권 이슈 - 임시 코드. 제거 기한 미정
   */
  setIsLimited(isLimited: boolean) {
    this.isLimited = isLimited

    if (isLimited) {
      localStorageService.setItem('PERSIST_LIMITED')(true)
    } else {
      localStorageService.removeItem('PERSIST_LIMITED')
    }
  }
}
